import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import PreviewSheet from "src/components/PreviewSheet"

import JobProgressBar, { JOB_STATUS_DISPLAY_ORDER } from "./JobProgressBar"
import { JOB_STATUS_CONFIG } from "./JobStatusBadge"

const WorkOrderJobProgress = ({ jobProgress }) => {
  const { total, percentComplete, counts } = jobProgress

  if (!total) {
    return <span className="text-gray-400">—</span>
  }

  return (
    <PreviewSheet href="">
      <PreviewSheet.Trigger>
        <span className="flex items-center gap-2" style={{ width: 150 }}>
          <span className="flex-1">
            <JobProgressBar counts={counts} total={total} />
          </span>
          <span className="w-10 whitespace-nowrap text-right text-sm text-gray-700">
            {percentComplete}%
          </span>
        </span>
      </PreviewSheet.Trigger>
      <PreviewSheet.Content>
        <div className="w-56">
          <div className="mb-2 flex items-baseline justify-between">
            <span className="font-semibold text-gray-900">
              {total} {total === 1 ? "job" : "jobs"}
            </span>
            <span className="text-sm text-gray-500">
              {percentComplete}% Done
            </span>
          </div>
          <JobProgressBar counts={counts} total={total} />
          <div className="mt-3 flex flex-col gap-2">
            {JOB_STATUS_DISPLAY_ORDER.filter(
              ({ countKey }) => counts[countKey] > 0
            ).map(({ countKey, status }) => (
              <div
                key={countKey}
                className="flex items-center gap-2 text-sm text-gray-700"
              >
                <span className="w-4 text-right font-semibold text-gray-900">
                  {counts[countKey]}
                </span>
                <span
                  className={classNames(
                    "h-2 w-2 rounded-full",
                    JOB_STATUS_CONFIG[status].dotColor
                  )}
                  aria-hidden="true"
                />
                {JOB_STATUS_CONFIG[status].label}
              </div>
            ))}
          </div>
        </div>
      </PreviewSheet.Content>
    </PreviewSheet>
  )
}

WorkOrderJobProgress.propTypes = {
  jobProgress: PropTypes.shape({
    total: PropTypes.number.isRequired,
    percentComplete: PropTypes.number.isRequired,
    counts: PropTypes.objectOf(PropTypes.number).isRequired,
  }).isRequired,
}

export default WorkOrderJobProgress
